import { z } from 'zod';
/**
 * Règles transporteur — `01` §2.3, refondues le 10/09/2026.
 *
 * Il n'y a plus qu'**un seul type de règle** : un libellé, des conditions
 * (origine, mode de livraison, pays, code postal, canal) et un résultat (code
 * Martelet). La liste est globale et ordonnée ; le **premier match gagne**.
 * Les anciennes « règles système » (Corse, Monaco, TikTok) sont devenues des
 * règles ordinaires, visibles et modifiables comme les autres, et le niveau de
 * spécificité (`tier`) a disparu avec elles.
 */
/** Comparaison d'un texte (mode de livraison) — `01` §2.3. */
export const CARRIER_TEXT_MATCH_KINDS = ['exact', 'contains', 'startsWith'];
export const carrierTextMatchKindSchema = z.enum(CARRIER_TEXT_MATCH_KINDS);
export const CARRIER_TEXT_MATCH_KIND = {
    exact: { code: 'exact', label: 'Exact', tone: 'gray' },
    contains: { code: 'contains', label: 'Contient', tone: 'gray' },
    startsWith: { code: 'startsWith', label: 'Commence par', tone: 'gray' },
};
/**
 * Comparaison d'un code postal. `notContains` existe parce que la v1 excluait
 * la Corse d'une règle France en testant l'absence du préfixe `20`.
 */
export const CARRIER_POSTAL_CODE_MATCH_KINDS = ['startsWith', 'contains', 'notContains'];
export const carrierPostalCodeMatchKindSchema = z.enum(CARRIER_POSTAL_CODE_MATCH_KINDS);
export const CARRIER_POSTAL_CODE_MATCH_KIND = {
    startsWith: { code: 'startsWith', label: 'Commence par', tone: 'gray' },
    contains: { code: 'contains', label: 'Contient', tone: 'gray' },
    notContains: { code: 'notContains', label: 'Ne contient pas', tone: 'gray' },
};
/**
 * Code d'origine des lignes venues de Pennylane. Les autres origines sont des
 * codes boutique Shopify (`fr`, `eu`…).
 */
export const PENNYLANE_ORIGIN = 'pennylane';
/** Comment le transporteur d'une commande a été obtenu (`01` §2.3). */
export const CARRIER_RESOLUTIONS = ['rule', 'default', 'no_shipping_line'];
export const carrierResolutionSchema = z.enum(CARRIER_RESOLUTIONS);
export const CARRIER_RESOLUTION = {
    rule: {
        code: 'rule',
        label: 'Règle',
        tone: 'green',
        description: 'Une règle transporteur a été retenue.',
    },
    default: {
        code: 'default',
        label: 'Transporteur par défaut',
        tone: 'orange',
        description: 'Aucune règle ne correspond : le transporteur par défaut de l’origine s’applique.',
    },
    no_shipping_line: {
        code: 'no_shipping_line',
        label: 'Sans mode de livraison',
        tone: 'gray',
        description: 'La commande n’a aucune ligne de livraison : transporteur par défaut, sans avertissement.',
    },
};
//# sourceMappingURL=carrier.js.map